import type { AxiosResponse } from 'axios';
import type {
  RemoveOrdersTags,
  RemoveOrdersTagsParams,
  RemoveOrdersTagsResponseBody,
} from './remove-orders-tags.service.types';
import { microServiceAPI } from '~/services/api';
import { WEB_ORDERS_API } from '~/services/web-orders.service';

/**
 * Removes the tags of multiple orders, the tags are appended to the orders existing tags.
 *
 * @param order_ids - The IDs of the orders to update.
 * @param tag_ids - The IDs of the tags to assign to the orders.
 * @return {Promise<AxiosResponse<RemoveOrdersTagsResponseBodyOrdersTagsResponseBody>>} Promise resolving to the updated orders.
 */
export const removeOrdersTags: RemoveOrdersTags = ({
  order_ids,
  tag_ids,
}: RemoveOrdersTagsParams): Promise<AxiosResponse<RemoveOrdersTagsResponseBody>> => {
  return microServiceAPI.request({
    url: `${WEB_ORDERS_API}/tags`,
    method: 'DELETE',
    data: {
      order_ids,
      tag_ids,
    },
  });
};
